import React, { useCallback } from "react"
import { FareOptionsResponse, SingleFareOptions } from "@ssc-booking/api-contracts"
import { Spinner } from "@silversea-ssc/ui-components-react"
import * as F from "fp-ts/function"
import * as O from "fp-ts/Option"
import * as ROA from "fp-ts/ReadonlyArray"
import { useECommerceMachine } from "../../_common/machines/machines-context"
import OptionalComponent from "../../../components/OptionalComponent"
import VsCheckbox from "../../../components/VsCheckbox/VsCheckbox"
import { useFareOptionsLoader } from "../_common/machines/ecommerce-machine/data-loading/fare-options-loader-machine"
import { customerIsVsMember } from "../_common/vs-code"
import styles from "./VsMemberCheckbox.module.scss"

const options = FareOptionsResponse.lensFromProp("options")
const vs = SingleFareOptions.lensFromProp("vs")
const availableVsOptions = F.flow(options.get, ROA.map(vs.get), ROA.compact)
const firstAvailableVsOption = F.flow(availableVsOptions, ROA.head)

const VsMemberCheckbox = () => {
    const [state, send] = useECommerceMachine()
    const [stateFO] = useFareOptionsLoader(state)

    const onVsMemberChange = useCallback(
        (maybeVsMember: boolean) => send({ type: "CHANGE_VS_MEMBER", maybeVsMember }),
        [send],
    )

    return (
        <>
            {F.pipe(
                O.fromNullable(stateFO.context.response),
                O.fold(
                    () => (
                        <div className={styles.spinner}>
                            <Spinner color={"neutral10"} size={"large"} />
                        </div>
                    ),
                    (response) =>
                        F.pipe(response, firstAvailableVsOption, (vsOption) => (
                            <OptionalComponent value={vsOption}>
                                {(vsOption) => (
                                    <VsCheckbox
                                        vsOption={vsOption}
                                        value={customerIsVsMember(state.context.vsCode)}
                                        onChange={onVsMemberChange}
                                    />
                                )}
                            </OptionalComponent>
                        )),
                ),
            )}
        </>
    )
}

export default VsMemberCheckbox
